import "./peopleList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import PeopleTable from "../peopletable/PeopleTable";

const PeopleList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <PeopleTable />
      </div>
    </div>
  );
};

export default PeopleList;
